import CharacterSelector from './CharacterSelector';
import LivesExplanation from './LivesExplanation';
import NameInput from './NameInput';
import TurtleIntro from './TurtleIntro';
import TurtleIntro2 from './TurtleIntro2';

export default [TurtleIntro, NameInput, CharacterSelector, TurtleIntro2, LivesExplanation];
